// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"dp-z","giftOrPromoSelector":"ep-z","disabled":"fp-z","subTitle":"gp-z","selectShipAddressMessage":"hp-z","changePayment":"ip-z"};